var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWdLogoW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199.898,
    height: 103.8,
    viewBox: "0 0 199.898 103.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 86.482,
    height: 82.392,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WD-Hindi-White",
    transform: "translate(-187.03 -139.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(187.03 139.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(7.209 10.705)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M878.978,118.551l3.185,2.673v.759l-1.908.255v.9l-.638.128-.638-1.279h-2.424l-.626,2.165-.776.261.645,1.268,1.268,1.4-.254.637-1.012.132v-1.792l-.9-1.268-.762.251v1.405l-2.042.258-.376-.258-.765.128v.889l-1.4.637-2.289.634-.261,1.145-1.658.132v-1.277h1.018v-1.017l-2.927-1.143-2.29.13-4.331,2.673-2.041.381-1.271,2.294.764.38h.631v1.652l.515.641,3.312-2.673-.261-.767,2.423-2.548,1.408.506-1.146.771-1.025.509-.5,1.777,1.659.132.38-.132.121.262-.372.381-1.787-.251-1.659,1.146-.385,1.4-1.271.512-2.549-.257v-1.018l.511-.634-1.024-.512-.631.889.251,1.021H851.6l-1.533.512-.763.642-.64-.518-3.179,1.146-.123,2.039-1.028,1.273-.765.385-2.547-1.016-.631.893-.378,1.907-1.782,1.652.885,1.665,2.3-.132,1.522-.518v-1.39l2.037-.9.771-.889,1.662.251.626-.129h1.146l.771,2.039,1.275,1.275-.388,1.4.388.135.633-.9-.12-1.022.636.774.378-.39-.766-1.018-.375-.382-.518-2.671,1.014.5,1.4,2.045.253,2.164,1.271,2.676.892-.257v-3.057l2.429.39h.626l-.25-1.665,1.788-1.652.121-.9h1.274v1.787l.765.385,1.405-.9-.64-.889,2.675-1.4.252.38-1.782.883.51,1.025,2.295,1.916-.382.631-1.786.39-.767.626-.885-1.14H861.91l-.894.385h-1.524l-1.026.381h-.5l-.632.637.632,2.039h3.7l.248.632h1.53l-.385,1.913-.756.762-.129,1.144-1.152.258-.76-.125,1.026,2.8,1.526.642,3.307,6.748,1.021,1.655.512,2.29,1.265.637,9.3-2.8,1.911-5.35-1.782-.771-2.162-.506-1.028.39-3.3-4.078h.759l4.721,3.437,1.263-.638,5.994-.253,4.577,2.674,2.041,6.5,2.679,3.313,1.91-1.662-.642-4.457,5.22-7.9,3.7,3.443,1.4,5.474,1.146,2.545,2.542,2.928.126-.763-.765-2.165-2.157-2.29V162.1l.631.134,2.164,2.928.767-3.565L909.8,159.3l-2.553-2.935v-2.924l1.66-.258.643-3.562.626.385.385-.385-.885-1.782-1.156-.767-.626-2.545-3.189-3.183-.385-1.023-1.533-1.273.385-2.293-1.146-4.845-2.418-2.416-2.29-2.035-1.9-1.536-2.427-1.646-2.547-1.4-2.669-1.272-2.676-1.15-2.8-1.021-2.929-.754Zm-40.5,27.884-3.693,3.188-1.655.509-3.561,4.715-.516,3.179-1.021,2.17,1.021,5.733,1.786,4.2,4.2.765h3.693l.255,1.4,1.907.385,1.021,2.924-.892,1.783,1.66,2.684,1.02,3.426,1.145.766v4.078l-.885,1.4,5.212,6.5,3.7,4.709h3.191l3.308-2.03.259-1.021,2.673-2.161-.257-2.548,3.946-3.193-1.277-7.635,6.753-6.5,2.3-7.13-4.849,1.4-.885-2.04-3.063-2.163-3.681-9.812-1.027-2.8h-1.905l-.771.259-3.055-2.045h-1.91l-.514,1.785-.885.512-4.583-4.713.247-2.42-5.859-.262-.374.892-1.4-.632Zm33.754,41.9-3.316,2.676-.632,3.944.632,2.174,1.785-.644.51-2.542,2.3-3.694-.125-1.027Zm-12.224-69.283-5.227,1.28-4.708,1.648-3.436,2.165-2.042,1.664.506.113,3.441-1.268,5.986-.509,4.073-1.524,4.456-2.043-1.143-1.272-1.4-.125Zm-9.048,6.758-1.786.89v.634l1.408.254.766-.512v-.895Zm11.978-3.575-.637.641.378,1.024h.26l.892-.771h.381v-.9Zm-12.611,9.044-1.658.261-.642,1.4.14.895-1.03.765-.64.125-.116.509.5.385,1.658-.512.381-.506.13-1.911,1.02-1.144Zm-3.316,1.276-1.521.381-.389,1.143-.634.516.257.506,1.521-.381.765-.889.127-.895Zm1.4,10.565-.766.646.379.377h.385v-1.021Zm-.247,1.533-.14-.256-.5.758.122.651.518-.39Zm2.665,2.418h-1.659l.261.638,1.146.381v-.635Zm11.08,3.179h-.76l-.514.385.646.38h.5l.127-.251Zm34.514,18.215-.512,1.145-.5,1.787.253.122,1.271-.889.255-1.021-.382-.255Zm9.806.513-1.526.122v1.273l1.912,1.024.632,1.907,1.91,1.655.517-.508-.124-2.164L906.866,170l-.635-.9Zm6.622-5.479-1.394,3.057-.261,5.474,1.655-.129.506-.254.385-2.67-.252-5.479ZM911.839,174.2l-1.913.9-.641,1.017,2.174-.129.5-.766Zm-.38-21.014-.261,1.277.763,1.655.893.9h.385l-.385-1.273-.377-2.163Zm1.778,5.1.257,2.67.892,1.017.126-1.655-.631-1.908Zm-36.174,35.524-.511.638.391.26h.385v-.637Zm1.788-.626-.511.763.381.258h.379v-.644Z",
    transform: "translate(-828.03 -118.551)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M912.556,172.363a46.058,46.058,0,1,1-.093-34.282H918.7a51.9,51.9,0,1,0,.078,34.282Z",
    transform: "translate(-817.862 -103.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M878.176,159.938,872.443,183.7h-7.061l-4.214-15.954L856.987,183.7h-7.064l-5.762-23.761h5.421l3.935,17.286,4.4-17.286h6.506l4.429,17.286,3.9-17.286Z",
    transform: "translate(-825.526 -119.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M911.547,179.156v4.461H895.871V160.135h15.521V164.6h-9.944v4.988h8.4v4.46h-8.4v5.112Z",
    transform: "translate(-840.608 -119.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M940.1,173.7a5.106,5.106,0,0,1,1.115,3.346,5.814,5.814,0,0,1-2.137,4.941q-2.137,1.626-7.126,1.626h-9.819V160.135h9.82q4.524,0,6.428,1.611a5.79,5.79,0,0,1,1.906,4.678,6.207,6.207,0,0,1-.775,3.222A5.146,5.146,0,0,1,937,171.69a6.509,6.509,0,0,1,3.1,2.015m-12.391-4.059h4.243q2.665,0,2.7-2.54a2.622,2.622,0,0,0-.635-1.968,2.926,2.926,0,0,0-2.06-.6h-4.243Zm6.954,5.021a4.85,4.85,0,0,0-2.711-.62h-4.243v5.174h4.243a4.789,4.789,0,0,0,2.8-.619,2.322,2.322,0,0,0,.819-1.983,2.19,2.19,0,0,0-.915-1.952",
    transform: "translate(-848.267 -119.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M991.174,181.232q-2.556-2.539-2.553-7.218V159.763H994.2v14.251a5.43,5.43,0,0,0,1.161,3.78,5.417,5.417,0,0,0,6.97,0,5.424,5.424,0,0,0,1.161-3.78V159.763h5.576v14.251q0,4.678-2.539,7.218t-7.683,2.54q-5.111,0-7.667-2.54",
    transform: "translate(-867.662 -119.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1041.486,159.763v23.482h-6.413l-8.427-14.436v14.436h-5.576V159.763h6.412l8.427,14.436V159.763Z",
    transform: "translate(-877.125 -119.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1091.751,178.753h-9.076l-1.642,4.769h-5.575l8.208-23.761h7.063l8.238,23.761h-5.576Zm-1.61-4.769-2.943-8.55-2.912,8.55Z",
    transform: "translate(-899.069 -119.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M972.315,163.125q-3.271-2.987-9.713-2.991h-3.46v0h-6.13a49.972,49.972,0,0,1,.06,23.478H962.6q6.474,0,9.727-2.943t3.253-8.768q0-5.794-3.268-8.783m-4.134,14.1q-1.765,1.686-5.576,1.688h-2.293a56.092,56.092,0,0,0-.031-14.067H962.6q3.747,0,5.545,1.674t1.8,5.3q0,3.718-1.766,5.405",
    transform: "translate(-857.274 -119.975)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M.324,0h5.9V23.472H.324Z",
    transform: "translate(167.295 39.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    transform: "translate(166.886 30.748)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdLogoW);
export default __webpack_public_path__ + "static/media/wd_logo_w.ea076a1bdc883ba6d85c654e9de6a1a4.svg";
export { ForwardRef as ReactComponent };